import CustomEvent from './CustomEvent';

export default CustomEvent;
